/** API route map: URLS.Controller.NewHirePacketSettings */
export const NewHirePacketSettings = {
      Name: 'NewHirePacket',
      GetInitialQuestionnaire: 'get-initial-questionnaire',
      AddInitialQuestion: 'add-initial-question',
      UpdateInitialQuestion: 'update-initial-question',
      UpdateInitialQuestionIndex: 'update-initial-question-indexes',
      UpdateInitialQuestionVisibility: 'update-initial-question-visibility',
      UpdateInitialQuestionRequirement: 'update-initial-question-requirement',
      GetPersonalInformation: 'get-personal-information',
      UpdatePiDescriptionAndWorkSiteInstructions: 'update-pi-desc-and-wsi',
      AddPiField: 'add-pi-field',
      UpdatePiField: 'update-pi-field',
      UpdatePiFieldsIndexes: 'update-pi-fields-indexes',
      UpdatePiFieldVisibility: 'update-pi-field-visibility',
      UpdatePiFieldRequirement: 'update-pi-field-requirement',
      GetEmergencyContact: 'get-emergency-contact',
      AddEcField: 'add-ec-field',
      UpdateEcField: 'update-ec-field',
      UpdateEcFieldsIndexes: 'update-ec-fields-indexes',
      UpdateEcFieldVisibility: 'update-ec-field-visibility',
      UpdateEcFieldRequirement: 'update-ec-field-requirement',
      GetJobInformation: 'get-job-information',
      AddJiField: 'add-ji-field',
      UpdateJiField: 'update-ji-field',
      UpdateJiFieldsIndexes: 'update-ji-fields-indexes',
      UpdateJiFieldVisibility: 'update-ji-field-visibility',
      UpdateJiFieldRequirement: 'update-ji-field-requirement',
      AddTask: 'add-task',
      GetTask: 'get-task',
      DeleteTask: 'delete-task',
      AddDirectDeposit: 'add-direct-deposit',
      GetDirectDeposit: 'get-direct-deposit',
      DeleteDirectDeposit: 'delete-direct-deposit',
      AddW4: 'add-w-4',
      GetW4: 'get-w-4',
      DeleteW4: 'delete-w-4',
      AddI9: 'add-i-9',
      GetI9: 'get-i-9',
      DeleteI9: 'delete-i-9',
      DeleteTaskBulk: '/delete-task-bulk',
      DeleteInitialQuestions: '/delete-initial-questions',
      DeletePiField: '/delete-pi-field',
      DeleteEcField: '/delete-ec-field',
      DeleteJiField: '/delete-ji-field',
};
